<script lang="ts">
    import Select from "svelte-select/Select.svelte"
    import { location, overlay } from "../../../../store"
    import { onMount } from "svelte"
    let {
        icon,
        options,
        value = $bindable(),
        placeholder,
        color,
        openSearch = false,
    }: {
        icon: string
        options: { value: string; label: string }[]
        value?: string
        placeholder?: string
        color?: "bright" | "dark"
        openSearch?: boolean
    } = $props()
    let hovered = $state(false) // Hover-Zustand
    let selectVisible = $state(false) // Sichtbarkeit des Select-Menüs
    let timer: NodeJS.Timeout | null = null // Timer für den 500ms-Hover

    function handleMouseEnter() {
        if (openSearch) return
        hovered = true

        // Starte den Timer, wenn 500ms am Stück gehovered wird
        if (!timer) {
            timer = setTimeout(() => {
                if (hovered) {
                    selectVisible = true // Zeige Select-Menü
                }
                timer = null
            }, 500)
        }
    }

    function handleMouseLeave() {
        if (openSearch) return
        hovered = false
        selectVisible = false // Blende Select-Menü aus
        if (timer) {
            clearTimeout(timer)
            timer = null // Lösche den Timer, wenn der Hover-Zustand unterbrochen wird
        }
    }
    let mounted = false // Flag, ob Komponente gemountet wurde

    onMount(() => {
        mounted = true
    })
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<div
    class="searchbar type-{color}"
    onmouseenter={handleMouseEnter}
    onmouseleave={handleMouseLeave}
    onclick={() => {
        if (openSearch) {
            $overlay.show = true
            $overlay.type = "search"
            return
        }
        hovered = true
        selectVisible = hovered
    }}
>
    <img src="/media/{icon}-{color == 'bright' ? 'white' : 'dark'}.svg" alt="Search Icon" />
    <div class="search-container {hovered ? 'expanded' : ''}">
        <div class="select-container {selectVisible ? 'visible' : ''}" class:hovered>
            <Select
                searchable={true}
                showChevron={true}
                items={options}
                placeholder={$location.path.includes("de") ? "Deutsch" : "English"}
                on:change={(e) => {
                    value = e.detail.value
                }}
            />
        </div>
    </div>
</div>

<style lang="less" global>
    .searchbar {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50px;
        background: rgba(255, 255, 255, 0.01);
        padding: 0.3rem;
        position: relative;
        transition: all 0.3s ease;
        height: fit-content;
        height: 2.4rem;
        min-width: 2.4rem;
        cursor: pointer;
        & > img {
            width: 24px;
            height: 24px;
        }

        .search-container {
            width: 0; /* Standardbreite */
            opacity: 0;
            cursor: pointer;
            transition:
                width 0.3s ease,
                opacity 0.3s ease;

            &.expanded {
                width: 150px; /* Breite der ausgefahrenen Searchbar */
                opacity: 1;
                padding-left: 0.3rem;
            }

            .select-container {
                opacity: 0;
                pointer-events: none; /* Deaktiviere Select-Menü */
                transition: opacity 0.3s ease;
                position: relative;
                cursor: pointer;
                display: none;
                &.hovered {
                    display: block;
                }
                &.visible {
                    opacity: 1;
                    pointer-events: auto; /* Aktiviere Select-Menü */
                }

                .svelte-select {
                    height: 24px;
                    cursor: pointer;
                    min-height: 24px !important;
                    max-height: 24px !important;
                    border: none !important;
                    background-color: transparent;
                    color: white;
                    .clear-select {
                        display: none !important;
                    }
                    input {
                        outline: none !important;
                        border: none !important;
                        &::placeholder {
                            color: white;
                        }
                    }
                    .svelte-select-list {
                        * {
                            color: var(--dark-100) !important;
                        }
                    }
                }
            }
        }
        &.type-dark {
            * {
                color: var(--dark-100) !important;
            }
            .svelte-select {
                color: var(--dark-100) !important;

                input {
                    &::placeholder {
                        color: var(--dark-100) !important;
                    }
                }
            }
        }
    }
</style>
